/**
 * Constants for toast notification durations.
 *
 * Centralizes the default and per-use-case durations so the store mutation,
 * the toast component's auto-close timer, and individual callers stay in sync.
 */

/**
 * Default toast auto-close duration in milliseconds. Used when a caller
 * does not specify a duration explicitly.
 */
export const DEFAULT_TOAST_DURATION_MS = 3000;
